import { Component } from '@angular/core';
import { toggleAnimation } from 'src/app/shared/animations';
import { IconModule } from '../../icon/icon.module';
import { IAuthUser } from 'src/app/interfaces/user.interface';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { DatetimeDisplayComponent } from '../datetime-display/datetime-display.component';
import { AuthService } from 'src/app/auth/services/auth.service';

@Component({
    selector: 'lc-profile',
    template: `
        <div *ngIf="user$ | async as user">
            <div class="flex flex-col items-center justify-center">
                <img
                    [src]="user.profilePicture || defaultProfilePicture"
                    alt="Foto de perfil"
                    class="mb-5 h-24 w-24 rounded-full object-cover shadow-lg border-2 border-primary/20"
                />
                <div class="justify-start text-tertiary dark:text-white text-2xl font-bold text-center">
                    Olá! {{ user.name.length > 20 ? user.name.slice(0, 20) + '...' : user.name }}
                </div>
                <div class="justify-start text-gray-600 dark:text-gray-300 text-base font-normal"> Bem-vindo na Infraseg </div>
            </div>
            <div class="mt-3">
                <lc-datetime-display />
            </div>
        </div>
    `,
    animations: [toggleAnimation],
    imports: [IconModule, CommonModule, DatetimeDisplayComponent],
    standalone: true,
})
export class ProfileComponent {
    user$: Observable<IAuthUser | null>;

    defaultProfilePicture: string = '/assets/images/defaultProfilePicture.png';

    constructor(private authService: AuthService) {
        this.user$ = this.authService.currentUser;
    }
}
